<template>
  <div class="user">
    <el-dropdown trigger="click">
      <div
          class="el-dropdown-link">
        <div class="dropdown__container">
          <span :class="{bold: isLeftNavCollapsed}">{{ user.email }} </span> <img
              :src="arrowDown"
              class="arrow__icon">
        </div>
        <div class="user-info">
          <div class="user-timezone">
            {{ currentTimezone }}
          </div>
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <router-link
              id="profile-button"
              :to="{ name: 'profile' }">
            View Profile
          </router-link>
        </el-dropdown-item>
        <el-dropdown-item
            v-if="isAdmin"
            divided>
          <router-link
              id="settings-button"
              :to="{ name: 'settings' }">
            Settings
          </router-link>
        </el-dropdown-item>
        <el-dropdown-item
            divided>
          <a
              id="logout-button"
              @click.prevent="takeMeOut()">
            <i class="el-icon-circle-close-outline" /> Logout
          </a>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { createNamespacedHelpers as vuexHelper } from "vuex";
const { mapGetters: uiGetters, mapActions: uiActions } = vuexHelper("ui");
const { mapActions: authActions, mapGetters: authGetters } = vuexHelper("auth");

export default {
  name: "UserOptions",
  data() {
    return {
      arrowDown: require("@/assets/icons/new-ui/main-header/profileMenuArrowDown.svg"),
    };
  },
  computed: {
    ...uiGetters(["currentTimezone", "isLeftNavCollapsed"]),
    ...authGetters(["user"]),
    isAdmin() {
      return this.$store.getters["auth/isAdmin"];
    },
  },
  methods: {
    ...uiActions(["setLoading"]),
    ...authActions(["logOut"]),
    takeMeOut() {
      this.$confirm("This will log you out. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.setLoading(true);
          this.logOut()
            .then(() => {
              this.$router.push({ path: "/login" });
              this.setLoading(false);
            })
            .catch((error) => {
              console.error("Could not logout");
            })
            .finally(() => {
              this.setLoading(false);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Logout canceled",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown__container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-dropdown-link {
  cursor: pointer;
  font-size: 14px;
  font-style: normal;
  font-weight: 200;
  color: #4c4c4c;
}

.el-dropdown-menu {
  text-align: center !important;
}
#logout-button {
  color: #f56c6c;
  margin-left: 10px;
  text-align: center;
}
#settings-button {
  text-align: center;
  color: grey;
  margin-left: 15px;
  text-decoration: none;
}
#profile-button {
  text-align: center;
  text-decoration: none;
}

.user-info .user-timezone {
  font-style: normal;
  font-weight: 200;
  float: left;
}

.arrow__icon {
  margin-left: 8px;
  transform: translateY(2px);
}

.bold {
  font-weight: 400;
  color: #4c4c4c;
}
</style>
